// https://firebase.google.com/docs/reference/js/auth.md#auth_package
import { initializeApp } from 'firebase/app'
import {
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  getIdTokenResult,
  GoogleAuthProvider,
  OAuthProvider,
  fetchSignInMethodsForEmail,
  linkWithCredential,
  signInWithCustomToken,
  RecaptchaVerifier,
  setPersistence,
  inMemoryPersistence,
} from 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FB_APIKEY,
  authDomain: process.env.VUE_APP_FB_AUTHDOMAIN,
  projectId: process.env.VUE_APP_FB_PROJECTID,
  storageBucket: process.env.VUE_APP_FB_STORAGE,
  messagingSenderId: process.env.VUE_APP_FB_MESSAGING,
  appId: process.env.VUE_APP_FB_APPID,
  measurementId: process.env.VUE_APP_FB_MEASUREMENT,
}

// init firebase
initializeApp(firebaseConfig)

const projectAuth = getAuth()
projectAuth.useDeviceLanguage()

export {
  projectAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  getIdTokenResult,
  fetchSignInMethodsForEmail,
  linkWithCredential,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithCustomToken,
  RecaptchaVerifier,
  setPersistence,
  inMemoryPersistence,
}
